import Client from '../axiosClient'
const resource = '/partner';
const resourceInit = 'partner_initialize';
const resourceUpdateStatus = '/partner_change_status';
const resourceReSchedulePriceJob = '/partner_re_schedule_price_job';
const resourcePartnerProfile = '/partner_by_user';
const resourcePartnerFilter = '/filter/partner';
const partnerUser = '/get_partners';
const resourceInstructor = '/instructor';
const resourceInstructorDelete = '/instructor_delete';
const resourceupdateSwitchIns = '/updateSwitchIns';



const resourcePartnerInit = 'partner_initialize_company';
const resourcePartnerfaqInit = 'partner_initialize_faq';
const resourcePartnerListInit = 'partner_list';


const partnerContact = '/store_partner_contact';
const resourcePartnerByUserId = '/get_partner_by_user_id';
const resourcePartnerNewUser = '/store_partner_new_user';

const updatecommsiondata = '/updatecommsion';

export default {


  updateSwitchIns(payload){
    return Client.post(`${resourceupdateSwitchIns}`, payload);
  },
  
  instdelete(payload) {
    return Client.post(`${resourceInstructorDelete}`, payload);
  },
  


  updatecommsion(payload){
    return Client.post(`${updatecommsiondata}`, payload);
  },


  init() {
    return Client.get(`${resourceInit}`);
  },

  PListinit() {
    return Client.get(`${resourcePartnerListInit}`);
  },

  getList(payload) {
    let filterParam='';
    if(payload) {
      console.log('partner Repository:',payload);
      let filterParam = 'requestFrom='+payload['requestFrom'];
      this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}`;
      return Client.get(`${resourcePartnerListInit}?${this.filterParam}`);
    //  return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);

  },

  compInit() {
    return Client.get(`${resourcePartnerInit}`);
  },
  faqInit() {
    return Client.get(`${resourcePartnerfaqInit}`);
  },


  contactPost(payload) {
    return Client.post(`${partnerContact}`, payload);
  },
  getByUserId(id) {
    return Client.get(`${resourcePartnerByUserId}/${id}`);
  },
  newUserPost(payload) {
    return Client.post(`${resourcePartnerNewUser}`, payload);
  },



  get(payload) {
    let filterParam='';
    if(payload) {
      console.log('partner Repository:',payload);
      let filterParam = 'requestFrom='+payload['requestFrom'];
      this.filterParam=filterParam+`&page=${payload['pageNo']}&pageLength=${payload['pageLength']}`;
      return Client.get(`${resourceInit}?${this.filterParam}`);
    //  return Client.get(`${resource}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}`);
    }
    return Client.get(`${resource}`);

  },

  getById(id) {
    return Client.get(`${resource}/${id}`);
  },

  post(payload) {
    return Client.post(`${resource}`, payload);
  },
 
  getPartnerProfile(id) {
    let dashPartnerId = id != undefined ? id : "0";
    return Client.get(`${resourcePartnerProfile}?user_id=${dashPartnerId}`);
  },
  updateStatus(payload) {
    return Client.post(`${resourceUpdateStatus}`, payload);
  },
  reSchedulePriceJob(payload) {
    return Client.post(`${resourceReSchedulePriceJob}`, payload);
  },
  getFilteredPartners (payload) {
    return Client.post(`${resourcePartnerFilter}`, payload);
  },
  getPartnerUsers() {
    return Client.get(`${partnerUser}`);
  },
  postInstructor(payload) {
    return Client.post(`${resourceInstructor}`, payload);
  },
  getInstructor(payload) {
    if(payload) {
      let partnerUserId = payload['dashPartnerId'] != undefined ? payload['dashPartnerId'] : "0";
      let partnerId = payload['partnerId'] != undefined ? payload['partnerId'] : "0";
      return Client.get(`${resourceInstructor}?page=${payload['pageNo']}&pageLength=${payload['pageLength']}&dashPartnerId=${partnerUserId}&partnerId=${partnerId}`);
    }
    return Client.get(`${resourceInstructor}`);

  },

  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/business/partnerRepository.js